import React from "react";
import "./hero.scss";
import Me from '../../Img/jhj.png'

const Hero = () => {
  return (
    <div className="hero-section flex">
      <div className="left">
        <h6>Hi Iam</h6>
        <h1>Shafiq Ssekitto </h1>
        <h4>Web & Graphics Designer</h4>
        <p>
          I am a frontend web developer, UX/UI and Graphics designer with over 9
          years of experience.
        </p>
        <button className="golden"><a href="https://shafiqresume.netlify.app/" target='blank'>Read my CV</a></button>
        <button className="gold"><a href="#contact">Hire me</a></button>
      </div>
      <div className="right">
        <img src={Me} alt="Shafiq" />
      </div>
    </div>
  );
};

export default Hero;
